import { moduleLabels, type AppModule } from '@/config/maintenanceModules';
import { useDeploymentSettingsStore } from '@/stores/deploymentSettings';
import type { RouteLocationNormalized } from 'vue-router';

export const getModuleLabel = (module?: string): string => {
    if (!module) return 'CapMagic';
    return moduleLabels[module as AppModule] ?? module;
};

export const getRouteModule = (to: RouteLocationNormalized): AppModule | undefined => {
    const record = [...to.matched].reverse().find((r) => r.meta.module);
    return record?.meta.module as AppModule | undefined;
};

export const isRouteUnderMaintenance = (
    to: RouteLocationNormalized,
    userEmail?: string
): boolean => {
    const module = getRouteModule(to);
    if (!module) {
        return false;
    }
    const store = useDeploymentSettingsStore();
    return store.shouldShowMaintenanceForUser(module, userEmail);
};

export const getMaintenanceModule = (to: RouteLocationNormalized): AppModule | undefined =>
    getRouteModule(to);
